"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoftTissueConditionType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var SoftTissueConditionType_Factory = /** @class */ (function () {
    function SoftTissueConditionType_Factory() {
    }
    SoftTissueConditionType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    SoftTissueConditionType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return SoftTissueConditionType_Factory;
}());
exports.SoftTissueConditionType_Factory = SoftTissueConditionType_Factory;
